import React from 'react';
import { usePortal } from '../../context/PortalContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function ChildSelector() {
  const { children, activeStudentId, setActiveStudentId } = usePortal();
  if (!children?.length) return null;
  if (children.length === 1) {
    const c = children[0];
    return (
      <p className="text-sm text-muted-foreground">
        Viewing: <span className="font-medium text-foreground">{c.first_name} {c.last_name}</span>
        {c.class_name ? ` · ${c.class_name}` : ''}
      </p>
    );
  }
  return (
    <Select value={String(activeStudentId || '')} onValueChange={(v) => setActiveStudentId(Number(v))}>
      <SelectTrigger className="w-[280px]">
        <SelectValue placeholder="Select child" />
      </SelectTrigger>
      <SelectContent>
        {children.map((c) => (
          <SelectItem key={c.id} value={String(c.id)}>
            {c.first_name} {c.last_name} {c.class_name ? `(${c.class_name})` : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
